var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBurgerV2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#5472CC",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 10c0-.552.373-1 .833-1h18.334c.46 0 .833.448.833 1s-.373 1-.833 1H6.833C6.373 11 6 10.552 6 10M6 16c0-.552.373-1 .833-1h18.334c.46 0 .833.448.833 1s-.373 1-.833 1H6.833C6.373 17 6 16.552 6 16M6 22c0-.552.373-1 .833-1h18.334c.46 0 .833.448.833 1s-.373 1-.833 1H6.833C6.373 23 6 22.552 6 22"
})));
export default SvgBurgerV2;